export * from './LocationResultCardImg';
